// eslint-disable-next-line @nx/enforce-module-boundaries
import { useExperiment } from 'shared/experiment'
import { type Assessment } from 'shared/types'

import { type Entity } from '~/domains/platform/infra/deus-ex-machina/ports'

import { type KYC } from '../kyc-onboarding.component'

import { type OnboardingSubject, organizationAccountRequestStatus } from './organization-account-request-status'

const flagContaLimitadaWeb = 'flag_conta_limitada_web'

type UseKycStatusOnboarding = {
  kycStatusPending: boolean
  kycStatusRejected: boolean
}

const disableKycStatusOnboarding: UseKycStatusOnboarding = {
  kycStatusPending: false,
  kycStatusRejected: false
}

export const useKycStatusOnboarding = (
  subjectId: string,
  statusKyc: KYC,
  reason?: Assessment['reason'],
  entity?: Entity<'banking' | 'acquirer'>,
  subject?: OnboardingSubject
): UseKycStatusOnboarding => {
  const { isFeatureFlagEnabled } = useExperiment(subjectId, flagContaLimitadaWeb)

  if (entity?.stoneAccount?.situation === 'one_stone') {
    const kycStatus = entity.stoneAccount.kyc?.status
    const subjectKycStatus = subject?.kyc?.status
    return {
      kycStatusPending:
        (kycStatus !== 'approved' && Boolean(entity.stoneAccount.kyc?.shouldRedirect)) ||
        (subjectKycStatus !== 'approved' && Boolean(subject?.kyc?.shouldRedirect)),
      kycStatusRejected: kycStatus === 'rejected'
    }
  }

  if (organizationAccountRequestStatus(entity, subject)) {
    return { kycStatusPending: true, kycStatusRejected: false }
  }

  if (isFeatureFlagEnabled) {
    return {
      kycStatusPending: statusKyc !== 'approved' && reason === 'account_request',
      kycStatusRejected: statusKyc === 'rejected'
    }
  }

  return disableKycStatusOnboarding
}
